// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBEbfRR0KifarSU3L4SulxFegP3inFncz0",
    authDomain: "abdoulazizdione-af723.firebaseapp.com",
    databaseURL: "https://abdoulazizdione-af723.firebaseio.com",
    projectId: "abdoulazizdione-af723",
    storageBucket: "abdoulazizdione-af723.appspot.com",
    messagingSenderId: "427910625657",
    appId: "1:427910625657:web:3f1096ee3240cdc74e97a8",
    measurementId: "G-N7ZLWM9KML"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
